<template>
	<div>
		<div class="channel-block" v-for="(list,i) in channelList" :key="list.columnId">
			<h1 class="channel-title">{{list.columnName}}<a :href="stockUrl+'video/listPage?mainColumnId='+list.columnId"  class="channel-more">查看更多>></a></h1>
			<div class="channel-block-wrapper">
				<ul class="channel-block-pic-list">
					<li v-for="(item,index) in list.videoList" :key="item.id">
						<a :href="stockUrl+'play/'+item.diversityId+'/'+item.videoId+'.html'">
							<!--<span v-show="!index">置顶</span>-->
		        			<img v-if='item.titleImg' :src="item.titleImg"/>
		        			<img v-else src="../../static/pic66.jpg"/>
		        			<div v-if="item.diversityName" class="video-des">{{item.diversityName}}</div>
		        			<div v-else class="video-des">标题暂无</div>
		        			<div class="hover-box">
		        				<p class="hover-title" :title="item.diversityName">{{item.diversityName}}</p>
		        				<p class="hover-des" :title="(item.videoParentColumnName?item.videoParentColumnName:'栏目')+':'+item.videoColumnName">{{item.videoParentColumnName?item.videoParentColumnName:'栏目'}}：{{item.videoColumnName}}</p>
		        				<p class="hover-name">讲师：{{item.videoLecturer}}</p>
		        				<p class="hover-time">
		        					<span>{{item.diversityTime}}</span>
		        					<span>{{item.clickRate}}</span>
		        				</p>
		        			</div>
		        		</a>
					</li>
				</ul>
				<div class="no-data-video" :class="{'video-nodata':isTrue[i]}">{{list.columnName}}视频暂无</div>
				<div class="channel-block-news-list">
					<h1 class="channel-title">相关资讯<a :href="stockUrl+'information/index?mainColumnId='+list.parentId+'&columnId='+list.columnId">更多>></a></h1>
					<ul class="channel-news-list">
						<li v-for="prop in list.informationList" :key="prop.id">
							<p><a :href="stockUrl+'information/'+prop.id+'?index=2'">{{prop.title}}</a></p>
							<p>
								<span>{{prop.source}}</span>
								<span>{{prop.author}}</span>
								<span>{{prop.publishTime}}</span>
							</p>
						</li>
					</ul>
					<div class="no-data-info" :class="{'info-nodata':isTrue1[i]}">{{list.columnName}}相关资讯暂无</div>
					<a v-if="adsimg[i]" :href="adsimg[i].imgLink" target="_blank">
						<img :src="adsimg[i].imgSrc" alt="麟龙选股决策" />
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
	export default{
		data(){
			return {
				channelList:[],
				stockUrl:window.stockUrl,
				isTrue:[],
				isTrue1:[]
			};
		},
		props:{
			adsimg:{
				type:Array
			}
		},
		mounted(){
    	this.getData();
    	},
    methods:{
    	getData: function() {
    		var $this=this;
    		var opts={
		    	 	isLoading:true,
		    	 	loadingDom:'div.channel-block',
		    	 	success:function(result){
		    	 		if (result.data && result.data.length) {
							result.data.forEach(function(value,index){
								if (value.informationList.length) {
									for(var i=0;i<value.informationList.length;i++){
										value.informationList[i].publishTime=$this.calcTime(value.informationList[i].publishTime);
										$this.$options.methods.handelData(value.informationList[i]);
									}
									$this.isTrue1.push(false);
								} else{
									$this.isTrue1.push(true);
								}
								if (value.videoList.length) {
									for(var j=0;j<value.videoList.length;j++){
//									value.videoList[j].publishTime=value.videoList[j].publishTime?$this.formatDate(value.videoList[j].publishTime):'暂无';
								    $this.$options.methods.handelData(value.videoList[j]);
									}
									$this.isTrue.push(false);
								} else{
									$this.isTrue.push(true);
								}
							});
							$this.channelList=result.data;
						} else{
							$this.$message({
								showClose: true,
								message: '数据加载失败！',
								type: 'warning'
							});
						}
		    	 	}
    	 		};
                $this.getAjaxCom('home/getStockHomeColumnData','get','',opts);
    	},
    	handelData:function(value){
    		if (value.clickRate!=null) {
    			if (value.clickRate) {
    				value.clickRate=value.clickRate?((value.clickRate>=10000)?((parseInt(value.clickRate/10000)==(value.clickRate/10000))?(value.clickRate/10000+'w'):((value.clickRate/10000).toFixed(2)+'w')):value.clickRate):value.clickRate;
    			}
			} else{
				value.clickRate='暂无';
			}
			
    		for (var prop in value) {
		    	if (!value[prop] && (prop!='titleImg')&& (prop!='clickRate')) {
		    	 	value[prop]='暂无';
		    	}
		    }
    		return value;
    	}
    }
}
</script>
<style lang="scss">
	h1.channel-title{
	overflow: hidden;
	font-size: 28px;
	font-weight: bold;
	line-height: 1.5;
	margin-bottom:16px;
	color:#333333;
	a{
		display: block;
		float: right;
		font-size: 14px;
		color: #666666;
		-webkit-transition: color .4s;
		-moz-transition: color .4s;
		-ms-transition: color .4s;
		-o-transition: color .4s;
		transition: color .4s;
		&:hover{
			color:#ff3c42;
			-webkit-transition: color .4s;
		-moz-transition: color .4s;
		-ms-transition: color .4s;
		-o-transition: color .4s;
		transition: color .4s;
		}
		&.channel-more{
			padding-top: 20px;
		}
	}
}
</style>
<style lang="scss" scoped="scoped">
@import '~scss/mixin';
 div.channel-block{
 	width: 1200px;
 	margin: 0 auto;
 	div.channel-block-wrapper{
 		width: 1150px;
 		height: 646px;
	 	margin: 0 auto;
	 	padding-top: 30px;
	 	background: #fff;
	    -webkit-box-shadow: 0 3px 15px rgba(154,154,154,.3);
        box-shadow: 0 3px 15px rgba(154,154,154,.3);
	    zoom: -1;
	    &:after{
	    	width: 0;
	    	height: 0;
	    	display: block;
	    	content: '';
	    	overflow: hidden;
	    	visibility: hidden;
	    	clear: both;
	    	font-size: 0;
	    }
	    ul.channel-block-pic-list{
	    	overflow: hidden;
	    	width: 894px;
	    	margin-left: -25px;
	    	float: left;
	    	li{
	    		width: 282px;
	    		height: 180px;
	    		float: left;
	    		margin-right: 24px;
	    		margin-bottom: 24px;
	    		overflow: hidden;
	    		position: relative;
	    		&:nth-child(3n){
	    			margin-right: 0;
	    		}
	    		&:first-child{
	    			a{
	    				>span{
	    					display: block;
	    					width: 56px;
	    					height: 26px;
	    					line-height: 26px;
	    					text-align: center;
	    					color: #FFFFFF;
	    					background-color: #ff4041;
	    					background-color: #ff4041;
	    					@include linear-gradient(right, #ff3c42, #ff643a);
	    					-webkit-border-radius: 26px;
	    					-moz-border-radius: 26px;
	    					border-radius: 26px;
	    					position: absolute;
	    					left: 12px;
	    					top: 12px;
	    				}
	    				
	    			}
	    		}
	    		 a{
                display: block;
                width: 100%;
                height: 100%;
                position: relative;
                &:after{
                	display: block;
                	content: '';
                	position: absolute;
                	left: 0;
                	right: 0;
                	top: 0;
                	bottom: 0;
                	background: url(~images/linear_bg.png) no-repeat center  center;
                	/*@include linear-gradient(bottom, rgba(0,0,0,0), rgba(0,0,0,.7));*/
                }
                img{
                    width: 100%;
                    height: 100%;
                }
                div.video-des{
                    width: 100%;
                    padding-left: 12px;
                    padding-right: 48px;
                    height: 58px;
                    line-height: 58px;
                    font-size: 16px;
                    color: #FFFFFF;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    z-index: 999;
                   
                    -webkit-transition: display 0.2s;
		            -moz-transition: display 0.2s;
		            -ms-transition: display 0.2s;
		            -o-transition: display 0.2s;
		            transition: display 0.2s;
		            -webkit-transform-origin: 50% 50%;
	                transform-origin: 50% 50%;
	                -webkit-transform:translate3d(0,0,0);
          	        transform:translate3d(0,0,0);
                    &:after{
                        display: block;
                        content: '';
                        width: 34px;
                        height: 34px;
                        background: url(~images/icon_play.png) no-repeat right center;
                        position: absolute;
                        right: 12px;
                        bottom: 12px;
                    }
                }
                div.hover-box{
                	z-index: 999;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(27,7,7,.8);
                    border-bottom: 3px solid #ff3c42;
                    position: absolute;
                    left: 0;
                    top: 0;
                    opacity: 0;
                    -webkit-transition: opacity 0.4s;
		            -moz-transition: opacity 0.4s;
		            -ms-transition: opacity 0.4s;
		            -o-transition: opacity 0.4s;
		            transition: opacity 0.4s;
		            -webkit-transform-origin: 50% 50%;
	                transform-origin: 50% 50%;
	                -webkit-transform:translate3d(0,0,0);
	                transform:translate3d(0,0,0);
                    color: #FFFFFF;
                    text-align: center;
                    padding: 48px 20px 0;
                    p{
                        width: 100%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        &.hover-title{
                          padding: 0;
                          text-align: center;
                          font-size: 16px;
                          font-weight: bold;
                          margin-bottom: 19px;  
                        }
                        &.hover-des{
                           font-size: 14px;
                           margin-bottom: 10px;
                           padding-left: 55px;
	                       padding-right: 55px;
	                       text-align: left;
                        }
                        &.hover-name{
                          font-size: 14px;
                          margin-bottom: 15px; 
                          padding-left: 55px;
	                      padding-right: 55px;
	                      text-align: left; 
                        }
                        &.hover-time{
                            font-size: 14px;
                            overflow: hidden;
                            span{
                                display: inline-block;
                                float: left;
                                &.firt-child{
                                    float: left;
                                }
                                &:last-child{
                                    float: right;
                                    text-align: right;
                                    background: url(~images/eye-icon.png) no-repeat left center;
                                    padding-left: 24px;
                                }
                            }
                        }
                    }
                }
                &:hover{
          	  	div.video-des{
          	  	display: none;
                -webkit-transition: display 0.2s;
		        -moz-transition: display 0.2s;
		        -ms-transition: display 0.2s;
		        -o-transition: display 0.2s;
		        transition: display 0.2s;
                -webkit-transform-origin: 50% 50%;
                transform-origin: 50% 50%;
                -webkit-transform:translate3d(0,0,0);
          	    transform:translate3d(0,0,0);
          	  }
          	  div.hover-box{
          	  	opacity: 1;
          	    -webkit-transition: opacity 0.4s;
          	    -moz-transition: opacity 0.4s;
          	    -ms-transition: opacity 0.4s;
          	    -o-transition: opacity 0.4s;
          	    transition: opacity 0.4s;
          	    -webkit-transform-origin: 50% 50%;
          	    transform-origin: 50% 50%;
          	    -webkit-transform:translate3d(0,0,0);
          	    transform:translate3d(0,0,0);
          	  }
          	  	&:after{
                  background: none;
              }
          	  }
            }
         
	    }
	    }
	    div.no-data-video{
	    	overflow: hidden;
	    	width: 894px;
	    	margin-left: -25px;
	    	float: left;
	    	text-align: center;
	    	font-size: 16px;
	    	display: none;
	    	&.video-nodata{
	    		display: block;
	    	}
	    }
	    div.channel-block-news-list{
	    	width: 282px;
	    	height: 589px;
	    	float: right;
	    	margin-right: -25px;
	    	background: #fff;
		    -webkit-box-shadow: 0 3px 15px rgba(154,154,154,.3);
            box-shadow: 0 3px 15px rgba(154,154,154,.3);
		    padding: 20px;
		    position: relative;
		    h1.channel-title{
		    	margin-top: 12px;
		    	font-size: 20px;
		    	margin-bottom: 6px;
		    }
		    ul.channel-news-list{
		    	color: #333333;
		    	li{
		    		overflow: hidden;
		    		margin-bottom: 13px;
		    		font-size: 16px;
		    		p{
		    			&:first-child{
		    				font-size: 16px;
		    				line-height: 1.5;
		    				width: 100%;
		    				overflow: hidden;
		    				text-overflow: ellipsis;
		    				white-space: nowrap;
		    				margin-bottom: 5px;
		    				-webkit-transition: color .4s;
							-moz-transition: color .4s;
							-ms-transition: color .4s;
							-o-transition: color .4s;
							transition: color .4s;
							
		    				a{
                        	&:hover{
                        		color:#ff3c42;
                        		-webkit-transition: color .4s;
								-moz-transition: color .4s;
								-ms-transition: color .4s;
								-o-transition: color .4s;
								transition: color .4s;
                        	}
                        }
		    			}
		    			&:last-child{
		    				font-size: 14px;
		    				color: #999999;
		    				overflow: hidden;
		    				span{
		    					display: block;
		    					float: left;
		    					margin-right: 14px;
		    					line-height: 1.5;
		    					&:last-child{
		    						float: right;
		    						margin-right: 0;
		    					}
		    				}
		    			}
		    			&:nth-child(2){
		    				span{
		    					overflow: hidden;
		    					text-overflow: ellipsis;
		    					white-space: nowrap;
		    					&:first-child{
		    						max-width: 57px;
		    					}
		    					&:nth-child(2){
		    						max-width: 57px;
		    					}
		    					&:last-child{
		    						max-width: 110px;
		    					}
		    				}
		    			}
		    		}
		    	}
		    }
		    div.no-data-info{
		    	margin-top: 15px;
		    	overflow: hidden;
		    	text-align: center;
		    	font-size: 16px;
		    	display: none;
		    	&.info-nodata{
		    		display: block;
		    	}
		    }
		    >a{
		    	display: block;
		    	width: 240px;
		    	height: 120px;
		    	position: absolute;
		    	left: 20px;
		    	bottom: 20px;
		    	img{
		    		width: 240px;
		    		height: 120px;
		    	}
		    }
	    }
	    
 	}
    
 }
</style>


// WEBPACK FOOTER //
// src/components/channel.vue